import { WidgetTypeDeviceList } from '@src/types/Widget';
import WidgetDeviceRowDetails from './WidgetDeviceRowDetailModal';
import { useEffect, useState, useRef } from 'react';
import DeviceDataTable, { DeviceDataTableRow } from './DeviceDataTable';
import { Theme } from '@emotion/react';
import { SxProps } from '@mui/material';
import { MqttClient } from 'mqtt/*';
import { generateMqttClient } from '@src/pages/_loader/initMqttClient.loader';
import storeConnector from '@src/store/storeConnector';
import { GridRowParams } from '@mui/x-data-grid';

function WidgetDeviceList({
  id,
  widgetConfig,
  sx,
  unitControllerId,
  unitControllerEngineeringId,
}: {
  id: string;
  widgetConfig: WidgetTypeDeviceList;
  sx?: SxProps<Theme>;
  unitControllerId?: string;
  unitControllerEngineeringId?: string;
}) {
  const { enableModalDetails } = widgetConfig;
  const [selectedSourceDevice, setSelectedSourceDevice] = useState<{
    name: string;
    id: string;
  } | null>(null);
  const [mqttClient, setMqttClient] = useState<MqttClient>();
  const mqttClientRef = useRef<MqttClient>();

  useEffect(() => {
    const startClient = async () => {
      const client = await generateMqttClient();
      mqttClientRef.current = client;
      setMqttClient(client);
    };
    startClient();
    return () => {
      mqttClientRef.current?.end();
    };
  }, []);

  return (
    <>
      <DeviceDataTable
        id={id}
        hideFooter
        additionalClassnames='detail-data-table'
        devices={widgetConfig?.devices || []}
        dataPoints={widgetConfig?.dataPoints || []}
        pointConfigRefs={widgetConfig?.pointConfigRefs || []}
        mqttClient={mqttClient}
        sx={sx}
        {...(enableModalDetails
          ? {
              onRowClick: ({ row }: GridRowParams<DeviceDataTableRow>) => {
                const { name, id } = row;
                setSelectedSourceDevice({ name, id });
              },
              getRowClassName: () => 'MuiDataGrid-clickable',
            }
          : {})}
      />
      {selectedSourceDevice && (
        <WidgetDeviceRowDetails
          widgetConfigId={widgetConfig.internalId}
          onClose={() => {
            setSelectedSourceDevice(null);
          }}
          selectedSourceDevice={selectedSourceDevice}
          unitControllerId={unitControllerId}
          unitControllerEngineeringId={unitControllerEngineeringId}
        />
      )}
    </>
  );
}

export default storeConnector(WidgetDeviceList, {
  config: ['siteMeta'],
});
